export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION ?? 'dev';

export function getBuildVersion(): string {
  return BUILD_VERSION;
}
